import React from 'react';
import { Helmet } from 'react-helmet-async';
import { META } from '../../../../constants';
import Error from '../Error';

const PageUnavailable = () => (
    <>
        <Helmet>
            <title>{META.unavailablePageTitle}</title>
        </Helmet>
        <Error />
    </>
);

export default PageUnavailable;
